/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Space({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#Space_svg__a)"><path d="M3.5 7.4a.6.6 0 0 0 0 1.2h9a.6.6 0 1 0 0-1.2h-9ZM5.4 5a.6.6 0 0 1 .6-.6h4a.6.6 0 1 1 0 1.2H6a.6.6 0 0 1-.6-.6ZM6 10.4a.6.6 0 0 0 0 1.2h4a.6.6 0 1 0 0-1.2H6Z" /><path fillRule="evenodd" d="M8 .4a7.6 7.6 0 1 0 0 15.2A7.6 7.6 0 0 0 8 .4ZM1.6 8a6.4 6.4 0 1 1 12.8 0A6.4 6.4 0 0 1 1.6 8Z" clipRule="evenodd" /></g><defs><clipPath id="Space_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;